import { useEffect } from "react";
import { stores } from "../stores/rootStore";
import "./policy.css";

export const Policy = () => {
  useEffect(() => {
    stores.helpUIStore.setTitle("Политика обработки персональных данных");
    stores.helpUIStore.setHistory(["policy"]);
  }, []);
  return (
    <div>
      <section id="general" className="section">
        <h2>1. Общие положения</h2>
        <p>
          1.1. Настоящая Политика обработки персональных данных (далее —
          Политика) определяет порядок обработки и защиты персональных данных
          физических лиц, предоставляемых ИП Лукянчук О.В. (далее — Оператор)
          при использовании веб-сайта{" "}
          <a href="https://cvetochnaya-lavka-irk.ru/">
            cvetochnaya-lavka-irk.ru
          </a>
          .
        </p>
        <p>
          1.2. Политика разработана в соответствии с Федеральным законом
          Российской Федерации от 27.07.2006 № 152‑ФЗ «О персональных данных» и
          иными нормативными правовыми актами Российской Федерации.
        </p>
        <p>
          1.3. Настоящая Политика применяется ко всей информации, которую
          Оператор может получить о Пользователях сайта.
        </p>
      </section>

      <section id="terms" className="section">
        <h2>2. Термины и определения</h2>
        <p>
          <strong>Персональные данные</strong> — любая информация, относящаяся к
          прямо или косвенно определённому физическому лицу (Пользователю).
        </p>
        <p>
          <strong>Обработка персональных данных</strong> — любое действие
          (операция) или совокупность действий с персональными данными, включая
          сбор, запись, систематизацию, накопление, хранение, уточнение
          (обновление, изменение), использование, передачу, обезличивание,
          блокирование, уничтожение.
        </p>
        <p>
          <strong>Пользователь</strong> — физическое лицо, предоставляющее свои
          персональные данные при заполнении форм на сайте.
        </p>
      </section>

      <section id="data" className="section">
        <h2>3. Персональные данные, которые обрабатывает Оператор</h2>
        <p>
          3.1. Оператор может обрабатывать следующие персональные данные
          Пользователя:
        </p>
        <ul>
          <li>фамилия, имя, отчество;</li>
          <li>контактный телефон;</li>
          <li>адрес электронной почты;</li>
          <li>почтовый адрес/адрес доставки;</li>
          <li>платёжные реквизиты (в случае оплаты заказа).</li>
        </ul>
        <p>
          3.2. Также на сайте осуществляется сбор и обработка обезличенных
          данных о посетителях с помощью сервиса интернет-статистики{" "}
          <strong>Яндекс.Метрика</strong>.
        </p>
      </section>

      <section id="purposes" className="section">
        <h2>4. Цели обработки персональных данных</h2>
        <p>4.1. Персональные данные Пользователя обрабатываются в целях:</p>
        <ul>
          <li>оформления и доставки заказов;</li>
          <li>связи с клиентами для уточнения деталей заказа;</li>
          <li>ведении клиентской базы и учёта заказов;</li>
          <li>повышения качества обслуживания и персонализации сервиса.</li>
        </ul>
        <p>
          4.2. Обезличенные данные используются для анализа статистики посещений
          и оптимизации работы сайта.
        </p>
      </section>

      <section id="law" className="section">
        <h2>5. Правовые основания обработки персональных данных</h2>
        <p>
          5.1. Обработка персональных данных осуществляется на основании
          согласия Пользователя, выраженного при заполнении форм на сайте, а
          также в случаях, предусмотренных действующим законодательством РФ
          (например, для исполнения договора).
        </p>
      </section>

      <section id="procedure" className="section">
        <h2>6. Порядок и условия обработки персональных данных</h2>
        <p>
          6.1. Оператор принимает необходимые организационные и технические меры
          для защиты персональных данных от неправомерного или случайного
          доступа, уничтожения, блокирования, копирования, распространения.
        </p>
        <p>
          6.2. Персональные данные не передаются третьим лицам без согласия
          Пользователя, за исключением случаев, установленных законодательством
          РФ.
        </p>
        <p>
          6.3. Срок хранения персональных данных: данные хранятся до достижения
          целей обработки или до отзыва согласия Пользователем, если иное не
          предусмотрено законом.
        </p>
      </section>

      <section id="rights" className="section">
        <h2>7. Права субъекта персональных данных</h2>
        <p>7.1. Пользователь имеет право:</p>
        <ul>
          <li>получать информацию об обработке своих персональных данных;</li>
          <li>
            требовать уточнения, блокирования или уничтожения своих персональных
            данных;
          </li>
          <li>отзывать согласие на обработку персональных данных.</li>
        </ul>
        <p>
          7.2. Для реализации указанных прав Пользователь может направить
          обращение на электронную почту Оператора:{" "}
          <a href="mailto:ordersroselux@gmail.com">ordersroselux@gmail.com</a>.
        </p>
      </section>

      <section id="withdrawal" className="section">
        <h2>8. Отзыв согласия на обработку персональных данных</h2>
        <p>
          8.1. Пользователь вправе в любой момент отозвать согласие на обработку
          персональных данных, направив уведомление на электронную почту
          Оператора с пометкой «Отзыв согласия на обработку персональных
          данных».
        </p>
        <p>
          8.2. После получения уведомления обработка персональных данных
          прекращается, а данные подлежат удалению, если иное не предусмотрено
          действующим законодательством.
        </p>
      </section>

      <section id="final" className="section">
        <h2>9. Заключительные положения</h2>
        <p>
          9.1. Оператор имеет право вносить изменения в настоящую Политику.
          Новая редакция вступает в силу с момента её размещения на сайте.
        </p>
        <p>
          9.2. Актуальная версия Политики доступна по адресу:{" "}
          <a href="https://cvetochnaya-lavka-irk.ru/policy">
            https://cvetochnaya-lavka-irk.ru/policy
          </a>
          .
        </p>
        <p className="policy__contacts">
          Контактная информация оператора: ИП Лукянчук О.В., E‑mail:{" "}
          <a href="mailto:ordersroselux@gmail.com">ordersroselux@gmail.com</a>.
        </p>
      </section>
    </div>
  );
};
